import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Gallery from './components/Gallery';

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<Gallery />} />
          </Routes>
        </main>
        <footer className="footer">
          <div className="footer-inner">
            <p>© {new Date().getFullYear()} Megapixel Photos. All rights reserved.</p>
            <a href="https://www.instagram.com/official_megapixelphotos" target="_blank" rel="noopener noreferrer" className="instagram-link">
              Follow us on Instagram
            </a>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
